/* Emphasised headline: pre + serif/sage word + post. Shared idiom
   used by every section headline. */
export function Em({ pre, em, post, className }) {
  return (
    <span className={className}>
      {pre}
      <span className="serif-em">{em}</span>
      {post}
    </span>
  )
}
